import { defineStyleConfig, } from '@chakra-ui/styled-system';
import { ThemeColorToken, ThemeFontSizeToken, ThemeFontToken, ThemeRadiusToken, ThemeSpaceToken, } from '../theme-tokens';
const BadgeVariants = [
    'Primary',
    'Secondary',
    'Success',
    'Error',
    'Info',
    'Neutral',
    'Warning',
];
const SolidVariants = BadgeVariants.reduce((solidVariants, key) => {
    const variant = solidVariants;
    const variantKey = `${key.toLowerCase()}Solid`;
    const bgKey = key;
    const textColor = `On${key}`;
    variant[variantKey] = {
        backgroundColor: ThemeColorToken[bgKey],
        textColor: ThemeColorToken[textColor],
    };
    return variant;
}, {});
const SubtleVariants = BadgeVariants.reduce((subtleVariants, key) => {
    const variant = subtleVariants;
    const variantKey = `${key.toLowerCase()}`;
    const bgKey = `${key}Container`;
    const textColor = `On${key}Container`;
    variant[variantKey] = {
        backgroundColor: ThemeColorToken[bgKey],
        textColor: ThemeColorToken[textColor],
    };
    return variant;
}, {});
const baseStyle = {
    borderRadius: ThemeRadiusToken.Small,
    display: 'flex',
    alignItems: 'center',
    px: ThemeSpaceToken.XSmall,
    height: '24px',
    textTransform: 'none',
    width: 'fit-content',
    fontFamily: ThemeFontToken.Body,
    fontWeight: 500,
};
export const badgeConfig = defineStyleConfig({
    baseStyle,
    sizes: {
        md: {
            fontSize: ThemeFontSizeToken.Small,
        },
        sm: {
            fontSize: ThemeFontSizeToken.XSmall,
        },
    },
    defaultProps: {
        size: 'md',
        variant: 'neutral',
    },
    variants: {
        ...SolidVariants,
        ...SubtleVariants,
    },
});
//# sourceMappingURL=badge-theme.js.map